module.exports = {
      id: "comm-video-usage",
      viewBox: "0 0 276.069 41.984",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-video",
      toString: function () {
        return this.url;
      }
    }